import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'app/core/services/common.service';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';
import { SalaryScaleService } from 'app/core/services/salary-scale.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-add-scaleline',
  templateUrl: './dialog-add-scaleline.component.html',
  styleUrls: ['./dialog-add-scaleline.component.scss']
})
export class DialogAddScalelineComponent implements OnInit {
  isLoading: boolean = false;
  scaleForm: FormGroup;
  workingDays: any;
  workingMonths: any;
  configData: any[] = [];

  today = new Date();
  endOfYear = new Date(this.today.getFullYear(), 11, 31);

  constructor(public dialogRef: MatDialogRef<DialogAddScalelineComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private salaryScaleService: SalaryScaleService, private commonService: CommonService,
    private refreshScaleLineService: RefreshScalelineService, private toastr: ToastrService) {
    this.scaleForm = this.fb.group({
      id: [0],
      scaleId: [this.data?.scaleId || 0],
      RAMP_Rate_Per_Period: ['0', [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      RAMP_Monthly_Rate: ['0', [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      Amount: ['0', [Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      RAMP_Amount2: ['0', [Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      RAMP_Amount3: ['0', [Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      RAMP_Hours_Per_Day: ['8', [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]*)?$/)]],
      MinValue: ['0', [Validators.pattern(/^\d+$/)]],
      MaxValue: ['0', [Validators.pattern(/^\d+$/)]],
      ValidFrom: [new Date(), Validators.required],
      ValidTo: [new Date(new Date().getFullYear(), 11, 31, 23, 59, 59), Validators.required],
    });
  }

  ngOnInit(): void {
    this.getSystems();
    if (this.data?.selectedScale?.RAMP_Salary_ScaleLine_ID > 0) {
      const selectedElement = this.data.selectedScale;
      this.scaleForm.patchValue({
        id: selectedElement.RAMP_Salary_ScaleLine_ID || 0,
        scaleId: selectedElement.RAMP_Salary_Scale_ID || 0,
        RAMP_Rate_Per_Period: selectedElement.RAMP_Rate_Per_Period || '0',
        RAMP_Monthly_Rate: selectedElement.RAMP_Monthly_Rate || '0',
        Amount: selectedElement.Amount || '0',
        RAMP_Amount2: selectedElement.RAMP_Amount2 || '0',
        RAMP_Amount3: selectedElement.RAMP_Amount3 || '0',
        RAMP_Hours_Per_Day: selectedElement.RAMP_Hours_Per_Day || '8',
        MinValue: selectedElement.MinValue || '0',
        MaxValue: selectedElement.MaxValue || '0',
        ValidFrom: selectedElement.ValidFrom ? new Date(selectedElement.ValidFrom) : null,
        ValidTo: selectedElement.ValidTo ? new Date(selectedElement.ValidTo) : null,
      });
    }
    if (this.data?.scaleId > 0) {
      this.scaleForm.patchValue({ scaleId: this.data.scaleId });
    }
    if (!this.data.dailyRate) {
      this.scaleForm.get('RAMP_Rate_Per_Period')?.setValidators(Validators.required);
    } else {
      this.scaleForm.get('RAMP_Rate_Per_Period')?.clearValidators();
      this.scaleForm.get('RAMP_Rate_Per_Period')?.setValue('0');
    }
    this.scaleForm.get('RAMP_Rate_Per_Period')?.updateValueAndValidity();

    this.scaleForm.get('RAMP_Monthly_Rate')?.valueChanges.subscribe((monthlyRateStr: string) => {

      const monthlyRate = parseFloat(monthlyRateStr);
      const workingDays = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_DAYS_YEARS')?.value || '0');
      const workingMonths = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_MONTHS')?.value || '1');

      if (!isNaN(monthlyRate) && monthlyRate > 0 && workingDays > 0 && workingMonths > 0) {
        const ratePerPeriod = monthlyRate / 2;
        const dailyRate = monthlyRate / (workingDays / workingMonths);
        const hourlyRate = dailyRate / 8;
        const minuteRate = hourlyRate / 60;

        this.scaleForm.patchValue({
          RAMP_Rate_Per_Period: ratePerPeriod.toString(),
          Amount: dailyRate.toString(),
          RAMP_Amount2: hourlyRate.toString(),
          RAMP_Amount3: minuteRate.toString(),
        }, { emitEvent: false });
      }
    });

    this.scaleForm.get('RAMP_Rate_Per_Period')?.valueChanges.subscribe((periodRateStr: string) => {

      const periodRate = parseFloat(periodRateStr);
      const workingDays = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_DAYS_YEARS')?.value || '0');
      const workingMonths = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_MONTHS')?.value || '1');

      if (!isNaN(periodRate) && periodRate > 0 && workingDays > 0 && workingMonths > 0) {
        const monthlyRate = periodRate * 2;
        const dailyRate = monthlyRate / (workingDays / workingMonths);
        const hourlyRate = dailyRate / 8;
        const minuteRate = hourlyRate / 60;

        this.scaleForm.patchValue({
          RAMP_Monthly_Rate: monthlyRate.toString(),
          Amount: dailyRate.toString(),
          RAMP_Amount2: hourlyRate.toString(),
          RAMP_Amount3: minuteRate.toString(),
        }, { emitEvent: false });
      }
    });
  }

  getSystems(): void {
    this.commonService.getConfigs().subscribe({
      next: res => {
        this.configData = res;
        this.workingDays = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_DAYS_YEARS')?.value || '0');
        this.workingMonths = Number(this.configData.find(c => c.name === 'CUSTOM_WORKING_MONTHS')?.value || '1');
      },
      error: err => {
        console.log(err);
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;

    if (this.scaleForm.invalid) {
      Object.keys(this.scaleForm.controls).forEach((controlName) => {
        this.scaleForm.get(controlName)?.markAsTouched();
        this.isLoading = false;
      });
      return;
    }
    if (this.scaleForm.valid) {
      this.salaryScaleService.createUpdateScaleLine(this.scaleForm.value).subscribe({
        next: res => {
          this.refreshScaleLineService.emitRefresh2(this.scaleForm.value.id);
          this.notify('Scale line saved successfully!', 'success');
          Promise.resolve().then(() => {
            this.isLoading = false;
            this.dialogRef.close();
          });
        },
        error: err => {
          console.log(err);
          this.isLoading = false;
          this.notify('Failed to save scale line. Please try again.', 'error');
        }
      });
    }
  }

  private notify(text: string, type: 'success' | 'error'): void {
    this.toastr.success(`<span class="now-ui-icons ui-1_bell-53"></span> ${text}`, '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: type === 'success' ? 'alert alert-success alert-with-icon' : 'alert alert-danger alert-with-icon',
      positionClass: 'toast-top-center',
    });
  }
}
